export default __webpack_public_path__ + "static/oeko-tex-standard-258d5194d922dfaf195ce214a6f8eb96.png";